import { cashIsArabic, cashName, cashText } from "@/lib/cash-language";
import type { CashDocument, CashMovement } from "@/hooks/use-branch-cash";

export function movementDocuments(m: CashMovement): CashDocument[] {
  const documents = [...(m.linkedDocuments || [])].map(d => d.kind === "maintenance_job" ? {...d, jobId: d.jobId || m.jobId || d.id, paymentId: d.paymentId || m.maintenancePaymentId} : d.kind === "job" && m.jobId ? {...d, kind: "maintenance_job" as const, jobId: m.jobId, paymentId: m.maintenancePaymentId || d.paymentId} : d);
  if(m.jobId&&!documents.some(d=>d.kind==="maintenance_job"))documents.push({kind:"maintenance_job",id:m.jobId,jobId:m.jobId,paymentId:m.maintenancePaymentId,reference:m.recordReference||m.reference});
  const add = (kind: CashDocument["kind"], id?: string | null, reference?: string | null) => {
    if (id && !documents.some(d => d.kind === kind && d.id === id)) documents.push({ kind, id, reference: reference || cashText("Open linked document") });
  };
  add("receipt", m.supplierReceiptId, m.receiptReference);
  add("return", m.supplierReturnId, m.returnNumber);
  add("collection", m.collectionId);
  add("float", m.personalFloatId);
  return documents;
}
export function maintenanceMovementHref(m: CashMovement) {
  const document=movementDocuments(m).find(d=>d.kind==="maintenance_job");
  if(!document)return null;
  const query=new URLSearchParams({job:document.jobId||document.id});
  if(document.paymentId)query.set("payment",document.paymentId);
  return `/maintenance/jobs/all?${query}`;
}
export function movementWhat(m: CashMovement, labels: Record<string, string>) {
  const type = m.originalMovementType || m.movementType;
  if(type==="employee_advance_repayment")return `${cashIsArabic()?"سداد سلفة نقداً":"Advance paid back"}${m.counterpartyName?` · ${m.counterpartyName}`:""}`;
  const supplierType = ["purchase", "advance", "supplier_payment"].includes(type);
  const title = supplierType ? cashText("Paid to supplier") : cashText(labels[type] || type);
  const who = supplierType || ["refund", "supplier_refund"].includes(type) ? m.supplierName || m.counterpartyName || (cashIsArabic() ? "المورد غير مسجل" : "Supplier not recorded") : m.expenseLineItemName ? cashName(m.expenseLineItemName, m.expenseLineItemNameAr) : "";
  const paidFor = m.forBranchId && m.forBranchId !== (m.paidFromBranchId || m.branchId) ? `${cashIsArabic() ? "مدفوع لصالح" : "Paid for"} ${m.forBranchName || m.forBranchId} · ` : "";
  return `${paidFor}${title}${who ? ` · ${who}` : ""}`;
}
export function carriedOpeningBalance(m: Pick<CashMovement, "movementType" | "notes">) {
  return m.movementType === "other_in" && /opening\s+balance|carried[\s-]*(?:over|forward)|رصيد[\s\S]*(?:مرحل|مرحّل|افتتاح)|(?:مرحل|مرحّل)[\s\S]*رصيد/i.test(m.notes || "");
}